import { PackOrEntrancePurchase } from 'storage/types';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import priceFormat from 'utils/formats/priceFormat';
import { Row, Col, Card } from 'antd';
import styles from './PackOrEntraceSummaryCard.module.scss';

interface Props {
  item: PackOrEntrancePurchase;
}

const PackOrEntraceSummaryCard: FC<Props> = ({ item }: Props) => {
  const { t } = useTranslation();

  return (
    <Row justify="center">
      <Col xs={20} lg={15}>
        <Card className={styles.Card}>
          <h2 className={styles.Title}>{item.name}</h2>
          <p>
            {item.adultTicketCount} {t('checkout.summary.adults')}
          </p>
          <p>
            {item.otherTicketCount} {t('checkout.summary.others')}
          </p>
          <p className={styles.SubTotal}>
            {t('checkout.summary.subTotal')}
            {priceFormat.format(
              item.adultValue * item.adultTicketCount +
                item.otherValue * item.otherTicketCount
            )}
          </p>
        </Card>
      </Col>
    </Row>
  );
};

export default PackOrEntraceSummaryCard;
